import ElCheckbox from 'element-ui/lib/checkbox'

export default {
  extends: ElCheckbox,
  computed: {
    isDisabled() {
      return this.isGroup
        ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled || this.isLimitDisabled
        : this.$options.propsData.hasOwnProperty('disabled')
        ? this.disabled
        : (this.elForm || {}).disabled
    },
  },
}
